import React from 'react';
import { Route, Routes, BrowserRouter } from 'react-router-dom';

/* pages */
import { Top, Worries, Terms, Interview, News, PmanComic, About, NewsList, SupportersVoice, Faq, Survey, Benefits, SurveyFloorPlan, SurveyRent01, SurveyRent02, SurveyForm, SurveyThanks, SurveyThanksMember } from './pages';
import { ScrollTop } from 'lib/scrill-to-top';

import './assets/styles/base.scss';

function App() {
  return (
    <BrowserRouter>
      <ScrollTop />
      <Routes>
        <Route path="/" element={<Top />} />
        <Route path="/worries" element={<Worries />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/interview" element={<Interview />} />
        <Route path="/news" element={<News />} />
        <Route path="/news-list" element={<NewsList />} />
        <Route path="/p-man-comic" element={<PmanComic />} />
        <Route path="/about" element={<About />} />
        <Route path="/supporters-voice" element={<SupportersVoice />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/survey" element={<Survey />} />
        <Route path="/survey/benefits" element={<Benefits />} />
        <Route path="/survey/floor-plan" element={<SurveyFloorPlan />} />
        <Route path="/survey/rent01" element={<SurveyRent01 />} />
        <Route path="/survey/rent02" element={<SurveyRent02 />} />
        <Route path="/survey/form" element={<SurveyForm />} />
        <Route path="/survey/thanks" element={<SurveyThanks />} />
        <Route path="/survey/thanks-member" element={<SurveyThanksMember />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
